<template>
    <div class="modal fade history-filter-modal forgetwithdrawModal-cl" id="ChangeAndWithdrawPassword" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="thm-heading">
                        <h3>{{ $t('change-password', 'Change password') }}</h3>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" v-if="$auth?.user?.last_login_at"></button>
                </div>
                <div class="modal-body">
                    <form class="withdraw_password_content">
                        <div class="cmn_withdraw_cl position-relative">
                            <input :type="passVisible.currentPassword ? 'text' : 'password'" v-model="form.currentPassword" class="form-control profit-input" :placeholder="$t('current-password', 'Current Password*')">
                            <i @click="togglePasswordVisibility('currentPassword')"  
                                :class="['fas', 'togglePassword', passVisible.currentPassword ? 'fa-eye-slash' : 'fa-eye']">
                            </i>
                            <span class="text-danger mt-2 error-messages-text" v-if="currentPasswordError && currentPasswordMsg == 'Invalid password !'">
                                {{ currentPasswordMsg }}
                            </span>
                        </div>
                    
                        <div class="cmn_withdraw_cl position-relative">
                            <input :type="passVisible.newPassword ? 'text' : 'password'" v-model="form.newPassword" @blur="checkPasswordValidation" class="form-control profit-input" :placeholder="$t('new-password', 'New Password*')">
                            <i @click="togglePasswordVisibility('newPassword')"  
                                :class="['fas', 'togglePassword', passVisible.newPassword ? 'fa-eye-slash' : 'fa-eye']">
                            </i>
                            <span class="text-danger mt-2 error-messages-text" v-if="newPasswordError">
                                New Password must be 6 char and alphanumeric
                            </span>
                            <span class="text-danger mt-2 error-messages-text" v-if="currentPasswordError && currentPasswordMsg == 'Old password does not accepted !'">
                                {{ currentPasswordMsg }}
                            </span>
                        </div>

                        <div class="cmn_withdraw_cl position-relative">
                            <input :type="passVisible.confirmNewPassword ? 'text' : 'password'" v-model="form.confirmNewPassword" class="form-control profit-input" placeholder="Confirm New Password*">
                            <i @click="togglePasswordVisibility('confirmNewPassword')"  
                                :class="['fas', 'togglePassword', passVisible.confirmNewPassword ? 'fa-eye-slash' : 'fa-eye']">
                            </i>
                        </div>

                        <template v-if="$siteSettings?.data?.business_type == 2">
                            <div class="cmn_withdraw_cl position-relative">
                                <input :type="passVisible.withdrawPassword ? 'text' : 'password'" v-model="form.withdrawPassword" @blur="checkWithDrawPasswordValidation" class="form-control profit-input" placeholder="New Withdraw Password*">
                                    <i @click="togglePasswordVisibility('withdrawPassword')"  
                                        :class="['fas', 'togglePassword', passVisible.withdrawPassword ? 'fa-eye-slash' : 'fa-eye']">
                                    </i>
                                <span class="text-danger mt-2 error-messages-text" v-if="withdrawPasswordError">{{ withdrawPasswordError }}</span>
                            </div>

                            <div class="cmn_withdraw_cl position-relative">
                                <input :type="passVisible.confirmWithdrawPassword ? 'text' : 'password'" v-model="form.confirmWithdrawPassword" class="form-control profit-input" placeholder="Confirm Withdraw Password*">
                                <i @click="togglePasswordVisibility('confirmWithdrawPassword')"  
                                    :class="['fas', 'togglePassword', passVisible.confirmWithdrawPassword ? 'fa-eye-slash' : 'fa-eye']">
                                </i>
                            </div>
                        </template>
                        <button @click.prevent="changePassword()" type="button" class="btn_submit_cl">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: "ChangeAndWithdrawPasswordModal",
    props:{
        handleUserIdAndOffer: Function
    },
    data(){
        return{
            form:{
                currentPassword: null,
                newPassword: null,
                confirmNewPassword: null,
                withdrawPassword: null,
                confirmWithdrawPassword: null,
            },
            withdrawPasswordError: null,
            newPasswordError: null,
            currentPasswordError: null,
            passVisible: {
                currentPassword: false,
                newPassword: false,
                confirmPassword: false,
                oldWithdrawPassword: false,
                newWithdrawPassword: false,
            },
        }
    },
    methods:{
        setUserIdsToStore() {
            let userid = this.$auth?.user?.userid
            let oldUserIds = this.$store.getters?.logInData?.userIds || [];
            let loginWithMobileFromAuth  = this.$store.getters?.logInData?.logInWithMobile
            let data = {
                logInWithMobile: loginWithMobileFromAuth,
                userIds: oldUserIds
            }
            this.$store.dispatch('setLogInData', data);
        },
        changePassword(){
            let isValid = this.applyPasswordValidation();
            if (isValid) {
                const changePasswordForm = new FormData();
                changePasswordForm.append("current_password", this.form.currentPassword);
                changePasswordForm.append("password", this.form.newPassword);
                changePasswordForm.append("confirm_password", this.form.confirmNewPassword);

                if (this.$siteSettings?.data?.business_type === 2) {
                    changePasswordForm.append("withdrawPassword", this.form.withdrawPassword);
                }
                this.$apiCall('post', 'CHANGE_PASSWORD', changePasswordForm).then(response => {
                    if (response?.status == 200) {
                        if (response?.data?.error) {
                            this.currentPasswordError = true;
                            this.currentPasswordMsg = response.data.error.toString();
                            this.$errorToast(response?.data?.error.toString());
                        }
                        else {
                            let user = this.$auth.user;
                            user.is_fresh = 0;
                            user.is_password_secure = 1;
                            user.is_withDraw_password = true;
                            user.last_login_at = Math.floor(new Date().getTime() / 1000);
                            this.$store.dispatch('setUser', user);
                            this.$successToast('Password changed successfully');
                            this.setUserIdsToStore();
                            this.$helper.closeModal('ChangeAndWithdrawPassword');
                            this.handleUserIdAndOffer();
                        }
                    }
                }).catch(error => {
                    this.loading = false;
                    if (error) {
                        console.log(error)
                        this.$errorToast(error[0]);
                    }
                });
            }
        },
        applyPasswordValidation(){
            if (this.$siteSettings?.data?.business_type == 2) { 

                const fields = [this.form.newPassword, this.form.confirmNewPassword, this.form.withdrawPassword, this.form.confirmWithdrawPassword];
                if (this.form.withdrawPassword !== this.form.confirmWithdrawPassword) {
                    this.$errorToast("Confirm WithDraw Password Does Not Match With New WithDraw Password");
                    return false;
                }
                if (fields.some(field => !field)) {
                    this.$errorToast('Please fill all the required fields.');
                    return false;
                }
            } else {
                // General validation for non-business type 2 users
                const fields = [this.form.newPassword, this.form.confirmNewPassword];
                if (fields.some(field => !field)) {
                    this.$errorToast('Please fill the required fields');
                    return false;
                }
            }
            return true;
        },
        checkWithDrawPasswordValidation() {
            var str = this.form.withdrawPassword;
            let regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,20}$/;
            this.withdrawPasswordError = '';
            if (str.length < 8 || str.length > 20) {
                this.withdrawPasswordError = 'Password length must be between 8 to 20 char';
            } else if (!regex.test(str)) {
                this.withdrawPasswordError = 'Withdraw password length should be 8 to 20 characters, it contains number, small, capital alphabet and special characters.';
            }
        },
        checkPasswordValidation() {
            const str = this.form.newPassword;

            const isTooShort = str.length < 6;
            const isTooLong = str.length > 50;
            const lacksNumber = !/\d/.test(str);
            const lacksLetter = !/[a-zA-Z]/.test(str);
            const hasInvalidChars = /[^a-zA-Z0-9!@#$%^&*()_+]/.test(str);
            this.newPasswordError = isTooShort || isTooLong || lacksNumber || lacksLetter || hasInvalidChars;
        },
        togglePasswordVisibility(field) {
            this.passVisible[field] = !this.passVisible[field];
        },
    }
}
</script>

<style scoped>
.modal.fade.history-filter-modal.forgetwithdrawModal-cl {
    z-index: 1054;
}
</style>